import { render, staticRenderFns } from "./FuncionalidadeSkeleton.vue?vue&type=template&id=148441ca&"
import script from "./FuncionalidadeSkeleton.vue?vue&type=script&lang=js&"
export * from "./FuncionalidadeSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FuncionalidadeSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports